import { useEffect, RefObject } from "react";

interface UseScrollOutsideProps {
  isOpen: boolean;
  onClose: () => void;
  enabled?: boolean;
  ref?: RefObject<HTMLElement>;
}

export const useScrollOutside = ({
  isOpen,
  onClose,
  enabled = true,
  ref,
}: UseScrollOutsideProps) => {
  useEffect(() => {
    if (!enabled || !isOpen) return;

    const handleScroll = (event: Event) => {
      // If no ref is provided, close on any scroll
      if (!ref?.current) {
        onClose();
        return;
      }

      // Check if the scroll event target is outside the dropdown ref
      const target = event.target as Element;
      if (!ref.current.contains(target)) {
        onClose();
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, [isOpen, onClose, enabled, ref]);

  return null;
};
